import { EventType } from '@/constants/event'
import { kafka, eventBus } from '@/instance'
import { Project } from '@/types'
import { RouteLocationNormalized } from 'vue-router'

export enum RouteRoomTag {
  None,
  Folder,
  RecycleBin,
  Search,
  Share,
  Collection,
  Review,
  Editor,
  Imagine
}

let currentRouteRoom = ''
export async function trackRoute (to: RouteLocationNormalized, from: RouteLocationNormalized) {
  const newRoom = await getRoomName(to, from)
  if (newRoom !== currentRouteRoom) {
    currentRouteRoom && kafka.send('leaveRoom', { roomName: currentRouteRoom })
    newRoom && kafka.send('joinRoom', { roomName: newRoom })
    currentRouteRoom = newRoom
  }
}

function getRoomName (to: RouteLocationNormalized, from: RouteLocationNormalized): Promise<string> {
  return new Promise((resolve) => {
    switch (to.meta.tag as RouteRoomTag) {
      case RouteRoomTag.Folder:
        if (to.params.guid) {
          resolve(`Asset/${to.params.guid}`)
        } else {
          // 这种情况怎么取文件夹id
          eventBus.once(EventType.PROJECT_READY, (project: Project) => resolve(`Asset/${project.root_asset}`))
        }
        break;
      case RouteRoomTag.RecycleBin:
        resolve(`Recycle/${to.params.id}`)
        break;
      case RouteRoomTag.Review:
      case RouteRoomTag.Editor:
      case RouteRoomTag.Imagine:
        resolve(`Asset/${to.params.id}`)
        break;
      case RouteRoomTag.Collection:
        resolve(`Collect/${to.params.id}`)
        break;
      case RouteRoomTag.Share:
        resolve(`Share/${to.params.id}`)
        break;
      default:
        resolve('')
        break;
    }
  })
}

